import AvgButtonIndex from '../../ComControl/AvgButtonIndex'
import AvgButton from '../../ComControl/AvgButton'
import FileName from '../../ComControl/FileName'
import { FileReader, FileWriter } from '@/platform'

class MessageDialogData {
    public X: number = 0
    public Y: number = 0 //坐标
    public BackPic: FileName = new FileName() //对话框背景图
    public FacePic: FileName = new FileName() //头像
    public f_x: number = 0
    public f_y: number = 0 //头像坐标
    public p_x1: number = 0
    public p_y1: number = 0 //文字坐标
    public p_viewW: number = 0
    public p_viewH: number = 0 //显示文字区域宽高
    public Buttons: AvgButton[] = [] //对话框按钮
    public ButtonsEx: AvgButtonIndex[] = []
    public BIndex: number[] = []

    constructor()
    constructor(option?: {
        x: number
        y: number
        backPic: FileName
        p_x: number
        p_y: number
        facePic: FileName
        f_x: number
        f_y: number
        btn: AvgButton[]
        btnIndex: AvgButtonIndex[]
        tempBIndex: number[]
    }) {
        if (option !== undefined) {
            this.X = option.x
            this.Y = option.y
            this.BackPic = option.backPic
            this.FacePic = option.facePic
            this.f_x = option.f_x
            this.f_y = option.f_y
            this.p_x1 = option.p_x
            this.p_y1 = option.p_y
            this.p_viewW = 0
            this.p_viewH = 0
            this.Buttons = option.btn

            if (option.btnIndex == null || option.tempBIndex == null) {
                this.BIndex = [9, 10, 11, 12, 13]
                this.ButtonsEx = new Array<AvgButtonIndex>(this.BIndex.length)
                for (let i: number = 0; i < this.BIndex.length; i++) {
                    if (this.Buttons) {
                        this.ButtonsEx[i] = new AvgButtonIndex(this.BIndex[i], 0, 0)
                    } else {
                        this.ButtonsEx[i] = new AvgButtonIndex(
                            this.BIndex[i],
                            this.Buttons[i]['X'],
                            this.Buttons[i]['Y']
                        )
                    }
                }
            } else {
                this.BIndex = option.tempBIndex
                this.ButtonsEx = option.btnIndex
            }
        }
    }

    // 头像Y坐标
    get F_y(): number {
        return this.f_y
    }
    set F_y(value: number) {
        if (value > 2000) {
            this.f_y = 2000
        } else if (value < -2000) {
            this.f_y = -2000
        } else {
            this.f_y = value
        }
    }

    // 头像X坐标
    get F_x(): number {
        return this.f_x
    }
    set F_x(value: number) {
        if (value > 2000) {
            this.f_x = 2000
        } else if (value < -2000) {
            this.f_x = -2000
        } else {
            this.f_x = value
        }
    }

    // 文字X坐标
    get P_x1(): number {
        return this.p_x1
    }
    set P_x1(value: number) {
        if (value > 2000) {
            this.p_x1 = 2000
        } else if (value < -2000) {
            this.p_x1 = -2000
        } else {
            this.p_x1 = value
        }
    }

    // 文字Y坐标
    get P_y1(): number {
        return this.p_y1
    }
    set P_y1(value: number) {
        if (value > 2000) {
            this.p_y1 = 2000
        } else if (value < -2000) {
            this.p_y1 = -2000
        } else {
            this.p_y1 = value
        }
    }

    // 文字显示区域的宽
    get P_viewW(): number {
        return this.p_viewW
    }
    set P_viewW(value: number) {
        if (value > 960) {
            this.p_viewW = 960
        } else if (value < -960) {
            this.p_viewW = -960
        } else {
            this.p_viewW = value
        }
    }

    // 文字显示区域的高
    get P_viewH(): number {
        return this.p_viewH
    }
    set P_viewH(value: number) {
        if (value > 540) {
            this.p_viewH = 540
        } else if (value < -540) {
            this.p_viewH = -540
        } else {
            this.p_viewH = value
        }
    }

    WriteData() {
        // TODO
    }

    /** cg_v3_data @DataStrucrParse：… → p_x1,p_y1,p_viewW,p_viewH → Buttons → ButtonsEx → BIndex */
    readBin(reader: FileReader): void {
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.BackPic = new FileName(reader)
        this.FacePic = new FileName(reader)
        this.f_x = reader.readInt()
        this.f_y = reader.readInt()
        this.p_x1 = reader.readInt()
        this.p_y1 = reader.readInt()
        this.p_viewW = reader.readInt()
        this.p_viewH = reader.readInt()

        this.Buttons = []
        const btnLen = reader.readInt()
        for (let i = 0; i < btnLen; i++) {
            const ab = new AvgButton()
            ab.readBin(reader)
            this.Buttons.push(ab)
        }

        this.ButtonsEx = []
        const btnExsLen = reader.readInt()
        for (let i = 0; i < btnExsLen; i++) {
            const avgBtn = new AvgButtonIndex()
            avgBtn.readBin(reader)
            this.ButtonsEx.push(avgBtn)
        }

        this.BIndex = []
        const biLen = reader.readInt()
        for (let i = 0; i < biLen; i++) {
            this.BIndex.push(reader.readInt())
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        this.BackPic.writeBin(writer)
        this.FacePic.writeBin(writer)
        writer.writeInt(this.f_x)
        writer.writeInt(this.f_y)
        writer.writeInt(this.p_x1)
        writer.writeInt(this.p_y1)
        writer.writeInt(this.p_viewW)
        writer.writeInt(this.p_viewH)

        writer.writeInt(this.Buttons.length)
        for (let i = 0; i < this.Buttons.length; i++) {
            this.Buttons[i]!.writeBin(writer)
        }

        writer.writeInt(this.ButtonsEx.length)
        for (let i = 0; i < this.ButtonsEx.length; i++) {
            this.ButtonsEx[i]!.writeBin(writer)
        }

        writer.writeInt(this.BIndex.length)
        for (let i = 0; i < this.BIndex.length; i++) {
            writer.writeInt(this.BIndex[i]!)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.FacePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.f_x = reader.readInt()
        this.f_y = reader.readInt()
        this.p_x1 = reader.readInt()
        this.p_viewW = reader.readInt()
        this.p_y1 = reader.readInt()
        this.P_viewH = reader.readInt()

        const btnExsLen = reader.readInt()
        for (var i = 0; i < btnExsLen; i++) {
            let avgBtn = new AvgButtonIndex()
            avgBtn.readVersionedOui(reader.readObj(reader.readInt()))
            this.ButtonsEx.push(avgBtn)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        this.BackPic.writeVersionedOui(writer)
        this.FacePic.writeVersionedOui(writer)
        writer.writeInt(this.f_x)
        writer.writeInt(this.f_y)
        writer.writeInt(this.p_x1)
        writer.writeInt(this.p_viewW)
        writer.writeInt(this.p_y1)
        writer.writeInt(this.P_viewH)

        writer.writeInt(this.ButtonsEx.length)
        for (let i = 0; i < this.ButtonsEx.length; i++) {
            const btn = this.ButtonsEx[i]
            btn.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default MessageDialogData
